import { render, staticRenderFns } from "./VerticalLayout.vue?vue&type=template&id=158c2127&scoped=true"
import script from "./VerticalLayout.vue?vue&type=script&lang=js"
export * from "./VerticalLayout.vue?vue&type=script&lang=js"
import style0 from "./VerticalLayout.vue?vue&type=style&index=0&id=158c2127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158c2127",
  null
  
)

export default component.exports